import { INetworkFilters, NetworkFilters } from "./networkFilters";
import { IPeriodAndSurveyTypeFilters, PeriodAndSurveyTypeFilters } from "./periodAndSurveyTypeFilters";
import { IProductFilters, ProductFilters } from "./productFilters";

export interface IFilters {
  network: INetworkFilters;
  product: IProductFilters;
  periodAndSurveyType: IPeriodAndSurveyTypeFilters
}
export class Filters implements IFilters {
  network: NetworkFilters = new NetworkFilters();
  product: ProductFilters = new ProductFilters();
  periodAndSurveyType: PeriodAndSurveyTypeFilters = new PeriodAndSurveyTypeFilters()
  constructor(object?: any) {
  }
}
